import { tokens, LILAC_600 } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSectionTitleWidgetStyles = function getSectionTitleWidgetStyles(transform, snapBgColor) {
  if (snapBgColor === void 0) {
    snapBgColor = LILAC_600;
  }
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      width: '100%'
    },
    iconImgContainer: {
      flexShrink: 0,
      flexDirection: 'row'
    },
    iconImg: {
      marginRight: 4
    },
    content: {
      flexDirection: 'column',
      flex: 1,
      width: '100%',
      flexShrink: 0
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    title: {
      marginRight: tokens.spacing.SPACING_4
    },
    titleContainerMargin: {
      marginBottom: tokens.spacing.SPACING_4
    },
    actionsContainer: {
      flexShrink: 0,
      paddingLeft: tokens.spacing.SPACING_8
    },
    infoIcon: {
      marginLeft: tokens.spacing.SPACING_4
    },
    snapContainer: {
      flexDirection: 'row',
      alignSelf: 'center',
      alignItems: 'center',
      flex: 1
    },
    snap: {
      height: tokens.spacing.SPACING_4,
      borderRadius: tokens.spacing.SPACING_4,
      backgroundColor: snapBgColor,
      marginLeft: tokens.spacing.SPACING_2,
      overflow: 'hidden'
    },
    snapProgress: {
      height: '100%',
      zIndex: 1,
      backgroundColor: snapBgColor,
      opacity: 1,
      transform: transform
    },
    unicodeTextStyle: {
      lineHeight: 16
    }
  });
};